import { http } from "@/shared/api/axios";
import { liveGuardsResponseSchema } from "../model/types";
import type { IncidentLocation } from "@/entities/incident";
import type { GuardLocationPing, LiveGuardResponse, LiveGuardsResponse } from "../model/types";

export const fetchLiveGuardLocations = async (params?: {
  shiftId?: number;
  siteId?: number;
  include?: string;
  incidentsFrom?: string;
}): Promise<LiveGuardsResponse> => {
  const response = await http.get<unknown>("/v1/guard-locations/live", { params });
  const parsed = liveGuardsResponseSchema.parse(response.data);

  return {
    guards: parsed.guards as LiveGuardResponse[],
    positionsDegraded: parsed.positionsDegraded ?? false,
    incidents: (parsed.incidents ?? undefined) as IncidentLocation[] | undefined,
    incidentsTruncated: parsed.incidentsTruncated ?? false,
  };
};

export const fetchGuardLocationHistory = async (
  shiftId: number,
  guardUserId: number
): Promise<GuardLocationPing[]> => {
  const response = await http.get<GuardLocationPing[]>(
    `/v1/guard-locations/shifts/${shiftId}/history`,
    { params: { guardUserId } }
  );
  return response.data;
};
